function mobileCatalog() {
    let catalogOpenBtn = document.querySelector('.js-open-catalog a');
    let catalogSubmenu = document.querySelector('.wrapper-mobile-submenu');
    let buttonBack = document.querySelectorAll('.button-back');
    let catalogSubmenuOpenBtn = document.querySelectorAll('.mobile-submenu-list__item');

    catalogOpenBtn.addEventListener('click',function (e) {
        e.preventDefault();
        catalogSubmenu.classList.add('open');
    });
    catalogSubmenuOpenBtn.forEach(function (element) {
        element.addEventListener('click',function () {
            element.querySelector('.mobile-submenu-list-2').classList.add('open');
        })
    });
    buttonBack.forEach(function (element) {
        element.addEventListener('click',function (e) {
            e.stopPropagation();
            element.closest('.open').classList.remove('open');
        })
    });

}
mobileCatalog();